import React from 'react';
// our components
import './Loading.css';
import PropTypes from 'prop-types';
import disabledContent from 'assets/jss/DisabledContent';
import withStyles from '@material-ui/core/styles/withStyles';

export const LoadingAnimation = () => (
  <div className="lds-ellipsis">
    <div />
    <div />
    <div />
    <div />
  </div>
);

/**
 * @description
 * Stateless component that render Loading
 *
 * @param {Object} props - Component props.
 * @returns {*} - Component to render or null.
 */
const Loading = ({ show, classes }) => {
  if (show) {
    return (
      <div>
        <div
          style={{ position: 'absolute' }}
          className={classes.disabledContent}
        />
        <div className={classes.loadingContainer}>
          <LoadingAnimation />
        </div>
      </div>
    );
  }
  return null;
};

Loading.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  show: PropTypes.bool.isRequired,
};

export default withStyles(disabledContent)(Loading);
